import React from 'react';
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component';
import Message from '../layout/Message';
import Button from '../layout/Button';

import {
    fetchPianoTechCustomerList,
    FIND_PIANOTECHCUSTOMER_STARTED,
    FIND_PIANOTECHCUSTOMER_SUCCEEDED,
    findPianoTechCustomer,
    fetchPianoTechCustomerListByCompany,
} from '../../actions/PianoTechCustomerActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_ADD,
    defaultPianoTechCustomer,
} from '../../app-constants';

const mapStateToProps = state => ({
    pianoTechCustomer: state.pianoTechCustomer,
    pianoTechCompany: state.pianoTechCompany,
    user: state.user,
});

class PianoTechCustomerTable extends React.PureComponent {
    componentDidMount() {
        const { adminUser, simulatingUser } = this.props.user;

        if (adminUser && !simulatingUser) {
            if (!this.props.pianoTechCustomer.pianoTechCustomerList || this.props.pianoTechCustomer.pianoTechCustomerList.length === 0)
                this.props.dispatch(fetchPianoTechCustomerList());
        } else {
            const { pianoTechCompany } = this.props.pianoTechCompany;
            if (!this.props.pianoTechCustomer.pianoTechCustomerList || this.props.pianoTechCustomer.pianoTechCustomerList.length === 0)
                this.props.dispatch(fetchPianoTechCustomerListByCompany(pianoTechCompany.companyId));
        }
    }

    refreshList = () => {
        const { adminUser, simulatingUser } = this.props.user;

        if (adminUser && !simulatingUser) {
            if (!this.props.pianoTechCustomer.pianoTechCustomerList || this.props.pianoTechCustomer.pianoTechCustomerList.length === 0)
                this.props.dispatch(fetchPianoTechCustomerList());
        } else {
            const { pianoTechCompany } = this.props.pianoTechCompany;
            if (!this.props.pianoTechCustomer.pianoTechCustomerList || this.props.pianoTechCustomer.pianoTechCustomerList.length === 0)
                this.props.dispatch(fetchPianoTechCustomerListByCompany(pianoTechCompany.companyId));
        }

    }

    addPianoTechCustomer = () => {
        const originalPianoTechCustomer = Object.assign({}, defaultPianoTechCustomer);

        const { pianoTechCompany } = this.props.pianoTechCompany;

        originalPianoTechCustomer.companyId = pianoTechCompany.companyId;

        const pianoTechCustomer = Object.assign({}, defaultPianoTechCustomer);

        pianoTechCustomer.companyId = pianoTechCompany.companyId;

        this.props.dispatch({
            type: FIND_PIANOTECHCUSTOMER_STARTED,
            maintenanceType: MAINTENANCE_TYPE_ADD,
            title: "Add PianoTechCustomer",
        });

        this.props.dispatch({
            type: FIND_PIANOTECHCUSTOMER_SUCCEEDED,
            pianoTechCustomer,
            originalPianoTechCustomer,
        });

    }

    viewPianoTechCustomer(customerId) {
        this.props.dispatch({
            type: FIND_PIANOTECHCUSTOMER_STARTED,
            maintenanceType: MAINTENANCE_TYPE_VIEW,
            title: "View Customer",
        });

        this.props.dispatch(findPianoTechCustomer(customerId));
    }

    render() {
        const columns = [
            {
                name: 'Customer Id',
                selector: row => row.customerId,
                sortable: true,
                width: '6%',
            },
            {
                name: 'Company Id',
                selector: row => row.companyId,
                sortable: true,
                width: '6%',
            },
            {
                name: 'Customer Name',
                selector: row => row.customerName,
                sortable: true,
                width: '10%',
            },
            {
                name: 'AddressLine1',
                selector: row => row.addressLine1,
                sortable: true,
                width: '10%',
            },
            {
                name: 'AddressLine2',
                selector: row => row.addressLine2,
                sortable: true,
                width: '10%',
            },
            {
                name: 'City',
                selector: row => row.city,
                sortable: true,
                width: '7%',
            },
            {
                name: 'State',
                selector: row => row.state,
                sortable: true,
                width: '6%',
            },
            {
                name: 'Country',
                selector: row => row.country,
                sortable: true,
                width: '6%',
            },
            {
                name: 'Email',
                selector: row => row.email,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Phone',
                selector: row => row.encryptedPhone,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Buttons',
                width: '8%',
                cell: row =>
                (
                    <>
                        <button
                            className="bluebutton2"
                            onClick={() => { this.viewPianoTechCustomer(row.customerId) }}
                            style={{ marginRight: "5px" }}
                        >View
                        </button>
                    </>
                )
            },
        ]
        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        return (
            <div>
                <Message message={this.props.pianoTechCustomer.message} type={this.props.pianoTechCustomer.messageType} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td className='lefttext'>
                                <Button className="bluebutton2" description="Refresh" onClick={this.refreshList} />
                                {this.props.user.allowAdd &&
                                    <Button className="bluebutton2-wide" description="Add Customer" onClick={this.addPianoTechCustomer} />
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
                <DataTable
                    title='Customers'
                    className='app-table'
                    columns={columns}
                    customStyles={customStyles}
                    striped
                    data={this.props.pianoTechCustomer.pianoTechCustomerList}
                    defaultSortField="customerName"
                    highlightOnHover
                    pagination
                    onRowClicked={
                        (row) => { this.viewPianoTechCustomer(row.customerId) }
                    }
                />
            </div>
        );
    }

}

export default connect(mapStateToProps)(PianoTechCustomerTable);
